import React, { useRef, useState, useEffect, useContext } from 'react';
import { RootStoreContext } from '../../../../App';

import * as S from './PromptAttendanceSelectBox.style';

import useAttendanceMutation from '../../../../hooks/queries/useAttendanceMutation';

const PromptAttendanceSelectBox = ({
	click,
	onClick,
	initValue,
	options,
	user,
	date,
}) => {
	const { authStore } = useContext(RootStoreContext);
	const [select, setSelect] = useState(initValue);

	const attendanceMutation = useAttendanceMutation();
	const isLoading = attendanceMutation.isLoading;

	const attendanceRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				attendanceRef.current &&
				!attendanceRef.current.contains(event.target) &&
				click
			) {
				onClick(false);
			}
		};

		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [click, onClick]);

	const selectChange = (value) => {
		console.log('user', authStore.auth);
		const updateData = {
			id: user?.attendanceId || 0,
			state: value,
			startTime: `${date.getFormatDate('yyyy,MM,dd')},${user.startTime[0]},${
				user.startTime[1]
			},0`,
			endTime: `${date.getFormatDate('yyyy,MM,dd')},${user.endTime[0]},${
				user.endTime[1]
			},0`,
			faceId: user.id,
			collectionId: authStore.auth?.collectionId,
		};
		attendanceMutation.mutate(updateData);
		setSelect(value);
		onClick(false); // 명시적으로 false 전달하여 옵션 닫기
	};

	return (
		<S.Container ref={attendanceRef} isLoading={isLoading}>
			<button onClick={onClick} disabled={isLoading}>
				{isLoading ? (
					<S.LoadingSpinner />
				) : (
					<>
						<S.Circle color={options[initValue].color} />
						{options[initValue]?.name}
					</>
				)}
			</button>
			{!isLoading && (
				<S.OptionsWrap click={click}>
					{Object.keys(options).map((key) => {
						return (
							<li key={key} onClick={() => selectChange(key)}>
								<S.Circle color={options[key].color} />
								{options[key].name}
							</li>
						);
					})}
				</S.OptionsWrap>
			)}
		</S.Container>
	);
};

export default PromptAttendanceSelectBox;
